import { getBranchGroupAssign } from '../../services/api/branchGroup.api';
import { GET_BRANCH_GROUP_ASSIGN_LIST_REQUEST, GET_BRANCH_GROUP_ASSIGN_LIST_SUCCESS, GET_BRANCH_GROUP_ASSIGN_LIST_FAILURE } from '../types';
import { transformBranchGroupAssigns } from '../../transforms/branchGroupAssign';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { mapTable } from '../../helpers/table';
import { replaceTo } from '../../helpers/utils';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformBranchGroupAssigns([]),
		pagination: transformPagination({}),
	},

	getters: {
		tableData: (state) => mapTable(state.data, {
			// left side is transform keys, right side is table field keys
			id: 'id',
			itecBranchId: 'branch_id',
			nameEn: 'branch_name',
			assignedAt: 'assigned_at',
		}),
	},

	mutations: {
		[GET_BRANCH_GROUP_ASSIGN_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_BRANCH_GROUP_ASSIGN_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformBranchGroupAssigns(data);
			state.pagination = transformPagination(meta);
		},
		[GET_BRANCH_GROUP_ASSIGN_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBranchGroupAssign({ commit }, { id, params }) {
			try {
				const sortBy = replaceTo(params.sort_by, [
					{ from: 'branch_id', to: 'id' },
					{ from: 'branch_name', to: 'name_th' },
				]);

				const _params = {
					...params,
					sort_by: sortBy,
				};

				commit(GET_BRANCH_GROUP_ASSIGN_LIST_REQUEST);
				const { data } = await getBranchGroupAssign(id, _params);
				commit(GET_BRANCH_GROUP_ASSIGN_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_BRANCH_GROUP_ASSIGN_LIST_FAILURE, error);
			}
		},
	},
};